// extracted by mini-css-extract-plugin
module.exports = {"quoteContainer":"PullQuote-module--quoteContainer--1ZJGZ","quote":"PullQuote-module--quote--1asA3","author":"PullQuote-module--author--3Y32c"};